import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface acknowledgeNotificationDataState {
  isLoading: boolean
  loadingError: string | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: acknowledgeNotificationDataState = {
  isLoading: false,
  loadingError: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const acknowledgeNotificationDataStateListState = createSlice({
  name: 'cacknowledgeNotificationDataStateData',
  initialState,
  reducers: {
    AcknowledgeNotificationLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        httpStatus: 0
      }
    },
    AcknowledgeNotificationUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    AcknowledgeNotificationErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  AcknowledgeNotificationLoadingAction,
  AcknowledgeNotificationUpdateAction,
  AcknowledgeNotificationErrorAction
} = acknowledgeNotificationDataStateListState.actions

export default acknowledgeNotificationDataStateListState.reducer
